import { Check } from 'lucide-react';
import { VIDEO_BACKGROUND_TEMPLATES, backgroundTemplateImageUrl } from '@/lib/videoEditorBackgroundTemplates';

export function BackgroundTemplatePicker({
  value = '',
  onChange,
  className = '',
  label = 'Background template',
}) {
  return (
    <div className={className} data-testid="background-template-picker">
      <p className="text-xs font-semibold text-slate-300 mb-2">{label}</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        <button
          type="button"
          onClick={() => onChange?.('')}
          className={`relative aspect-video rounded-lg border overflow-hidden transition-colors ${
            !value ? 'border-amber-400 ring-1 ring-amber-400/60' : 'border-slate-700 hover:border-slate-500'
          }`}
          data-testid="background-template-none"
        >
          <div className="absolute inset-0 bg-slate-900 flex items-center justify-center text-[10px] text-slate-500">
            None
          </div>
          {!value ? (
            <span className="absolute top-1 right-1 rounded-full bg-amber-400 text-black p-0.5">
              <Check className="w-3 h-3" />
            </span>
          ) : null}
        </button>
        {VIDEO_BACKGROUND_TEMPLATES.map((template) => {
          const selected = value === template.id;
          const src = backgroundTemplateImageUrl(template.id);
          return (
            <button
              key={template.id}
              type="button"
              title={template.name}
              onClick={() => onChange?.(template.id)}
              className={`relative aspect-video rounded-lg border overflow-hidden transition-colors ${
                selected ? 'border-amber-400 ring-1 ring-amber-400/60' : 'border-slate-700 hover:border-slate-500'
              }`}
              data-testid={`background-template-${template.id}`}
            >
              <img src={src} alt="" className="absolute inset-0 w-full h-full object-cover" />
              <span className="absolute bottom-0 left-0 right-0 px-1 py-0.5 text-[9px] text-white bg-black/55 truncate">
                {template.name}
              </span>
              {selected ? (
                <span className="absolute top-1 right-1 rounded-full bg-amber-400 text-black p-0.5">
                  <Check className="w-3 h-3" />
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default BackgroundTemplatePicker;
